import { isAxiosError } from 'axios';

import { ErrorResponseV2Error } from './axios';
import { ServerError } from './constants/server-error';

/**
 * 스크린샷을 통한 오류 제보시 개발자가 확인하기 위한 메시지입니다.
 */
export const getErrorMessageForDev = (error: unknown) => {
  if (error == null) return 'Null or undefined throwed';
  if (!isAxiosError(error) && error instanceof Error) return 'Tracked by datadog';
  if (isAxiosError(error)) return `${error.name}: status - ${error.status}, code - ${error.code}`;
  return error.constructor.name;
};

/**
 * 사용자에게 보여지는 에러 메시지를 반환합니다.
 */
export const getErrorMessage = (error: unknown) => {
  if (!error) return '';
  if (!isAxiosError(error) && error instanceof Error) {
    // oxlint-disable-next-line no-console
    console.error(error); // 개발자만 보면 되는 에러 - console error 경우 트래킹 됨
    return 'Unknown client Error';
  }
  if (typeof error === 'string') {
    if (error in ServerError) return ServerError[error];
    return error;
  }
  if (isAxiosError(error)) {
    if (error.response?.data) {
      const errorResponse: string | ErrorResponseV2Error = error.response.data.error;
      // v1
      if (typeof errorResponse === 'string') {
        const localeErrorMessage = error.response.data.message;
        // 빈 문자열인 경우 메시지가 없는 것으로 간주
        if (typeof localeErrorMessage === 'string' && localeErrorMessage.trim() !== '') {
          return localeErrorMessage;
        }
        if (ServerError[errorResponse]) return ServerError[errorResponse];
      }
      // v2 (아직 i18n 대응안됨)
      if (typeof errorResponse === 'object') {
        if (errorResponse.message) return errorResponse.message;
      }
    }
    return ServerError['api.server.error'];
  }
  return '';
};

/**
 * 에러 코드만 추출합니다. (i18n 메시지가 아닌 원본 에러 코드)
 */
export const getErrorCode = (error: unknown): string => {
  if (!error) return '';
  if (isAxiosError(error) && error.response?.data) {
    const errorResponse: string | ErrorResponseV2Error = error.response.data.error;
    // v1
    if (typeof errorResponse === 'string') {
      return errorResponse;
    }
    // v2
    if (errorResponse != null && typeof errorResponse === 'object') {
      return errorResponse.type;
    }
  }
  return 'api.server.error';
};

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getErrorDetailsObject = (error: unknown): Record<string, any> => {
  if (!isAxiosError(error)) return {};
  return error.response?.data?.errorDetails || {};
};

export const getServerFormError = (error?: { type: string; message?: string }) => {
  if (!error || error.type !== 'server' || !error.message) return undefined;
  return ServerError[error.message] ?? error.message;
};

export const getCustomFormError = (error?: { type: string; message?: string }) => {
  if (!error || error.type !== 'custom' || !error.message) return undefined;
  return error.message;
};
